import React, { FC, JSX } from 'react'
import { TouchableOpacity, View, ViewStyle } from 'react-native'

import CloseIcon from '@common/assets/svg/CloseIcon'
import ZKXLogo from '@common/components/ZKXLogo'
import { PanelBackButton } from '@common/components/Panel/Panel'
import Text from '@common/components/Text'
import spacings from '@common/styles/spacings'
import flexbox from '@common/styles/utils/flexbox'

import getStyles from './styles'

interface Props {
  hideLeftSideContainer?: boolean
  hideRightSideContainer?: boolean
  handleClose?: () => void
  withBackButton?: boolean
  title?: React.ReactNode
  titleSuffix?: JSX.Element
  style?: ViewStyle
  hasZkxLogo?: boolean
  children?: React.ReactNode
  // Narrow viewports (mobile-web): shrink the side containers and cap the
  // title at two lines so it stays centered instead of wrapping into a tall
  // narrow column on small screens.
  compact?: boolean
}

const ModalHeader: FC<Props> = ({
  hideLeftSideContainer = false,
  hideRightSideContainer = false,
  handleClose,
  withBackButton = true,
  title,
  titleSuffix,
  style,
  hasZkxLogo = false,
  compact = false
}) => {
  const styles = getStyles(compact)
  const showLogo = hasZkxLogo

  return (
    <View style={[styles.modalHeader, style]}>
      {!hideLeftSideContainer && (
        <View style={styles.sideContainer}>
          {!!handleClose && withBackButton && (
            <View style={styles.backButton}>
              <PanelBackButton onPress={handleClose} />
            </View>
          )}
        </View>
      )}
      {!!title && (
        <Text
          fontSize={20}
          weight="medium"
          numberOfLines={compact ? 2 : undefined}
          style={[
            compact && styles.compactTitle,
            !!titleSuffix && spacings.mrSm
          ]}
        >
          {title}
        </Text>
      )}
      {titleSuffix}
      {!hideRightSideContainer && (
        <View
          style={[
            styles.rightSideContainer,
            ...[
              showLogo && !!handleClose && !withBackButton
                ? flexbox.justifySpaceBetween
                : flexbox.justifyEnd
            ]
          ]}
        >
          {hasZkxLogo && <ZKXLogo width={30} />}
          {!!handleClose && !withBackButton && (
            <TouchableOpacity onPress={handleClose}>
              <CloseIcon />
            </TouchableOpacity>
          )}
        </View>
      )}
    </View>
  )
}

export default React.memo(ModalHeader)
